<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container>
      <v-row>
        <v-toolbar-title>
          <v-row class="pa-3 ma-5" align="center" justify="center">
            <span class="red--text">共 {{totalCount}} 筆，每頁筆數</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark text color="red" class="ml-2" v-on="on">
                  {{ pageSize }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-toolbar-title>

        <v-col cols="12" md="10">
          <v-data-iterator
            :items="items"
            :items-per-page.sync="pageSize"
            :page="currentPage"
            hide-default-footer
            no-data-text="查無資料"
          >
            <template v-slot:default="props">
              <v-row>
                <v-col v-for="(item,i) in props.items" :key="i" cols="12" sm="5" md="5" lg="6">
                  <v-card>
                    <v-card-title v-bind:class="{'red white--text':isItemExist(item)}">
                      <h3>{{ item.name }}</h3>
                      <h4>({{item.gender=='M'?'男':'女'}}) 案件數：{{ item.caseCount }}</h4>
                      <v-spacer />
                      <v-btn v-if="isHeartExist(item)" @click="deleteHeart(item)" class="ma-1">
                        <v-icon color="red">turned_in</v-icon>
                      </v-btn>
                      <v-btn v-if="!isHeartExist(item)" @click="addHeart(item)" class="ma-1">
                        <v-icon>turned_in_not</v-icon>
                      </v-btn>

                      <v-rating
                        readonly
                        v-model="item.score"
                        color="yellow darken-3"
                        background-color="grey darken-1"
                        empty-icon="$ratingFull"
                        half-increments
                        hover
                      ></v-rating>
                      <v-spacer />
                      <v-btn @click="dialog = !dialog;memberItem = item;" class="ma-1">
                        <v-icon>search</v-icon>
                      </v-btn>
                      <v-btn
                        @click="selectedArrayPushObject(item);updateTargetId(item.name);addAlertUtil();"
                        class="ma-1"
                        v-if="!isItemExist(item)"
                      >
                        <v-icon>mdi-account-plus</v-icon>
                      </v-btn>
                      <v-btn
                        @click="selectedArray.splice(findItemIndex(item),1)"
                        v-if="isItemExist(item)"
                        class="ma-1"
                      >
                        <v-icon>mdi-account-remove</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-list dense>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content class="align-end" v-on="on">{{ item.nationality }}</v-list-item-content>
                          </template>
                          <span>國籍</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ item.qualificationInTaiwan }}</v-list-item-content>
                          </template>
                          <span>在臺資格與取得證件</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ convertDBDateToString(item.serviceStartDate) }}</v-list-item-content>
                          </template>
                          <span>開始從事通譯服務時間</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ item.educationLevel }}</v-list-item-content>
                          </template>
                          <span>教育程度</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content class="align-end" v-on="on">{{ item.serviceType }}</v-list-item-content>
                          </template>
                          <span>服務類型</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ item.serviceLanguage }}</v-list-item-content>
                          </template>
                          <span>熟悉語言</span>
                        </v-tooltip>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </template>
            <template v-slot:footer>
              <v-row class="mt-2" align="center" justify="center">
                <!-- <span class="red--text">每頁筆數</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn dark text color="red" class="ml-2" v-on="on">
                      {{ pageSize }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(number, index) in itemsPerPageArray"
                      :key="index"
                      @click="updateItemsPerPage(number)"
                    >
                      <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-spacer></v-spacer>-->

                <!-- <span class="mr-4 red--text">Page {{ currentPage }} / {{ maxPage }}</span>
                <v-btn fab dark color="red darken-3" class="mr-1" @click="formerPage">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn fab dark color="red darken-3" class="ml-1" @click="nextPage">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>-->

                <div class="text-center pa-2 ma-2">
                  <v-pagination
                    color="red"
                    v-model="currentPage"
                    :length="maxPage"
                    :total-visible="9"
                    @input="getHeartList()"
                  ></v-pagination>
                </div>
              </v-row>
            </template>
          </v-data-iterator>
        </v-col>
        <v-col cols="12" md="2">
          <v-card
            v-show="selectedArray.length != 0"
            :style="{'top':offsetTop+'px','transition': 'all 0.5s'} "
          >
            <v-card-title>
              <h1>已選擇：{{selectedArray.length}}</h1>
            </v-card-title>
            <v-card-text v-for="(selectedItem,j) in selectedArray" :key="j">
              <h3>
                {{selectedItem.name}}
                <v-btn fab x-small @click="selectedArray.splice(j,1)">
                  <v-icon>mdi-account-remove</v-icon>
                </v-btn>
              </h3>
            </v-card-text>
            <v-card-actions>
              <v-btn color="red" block @click="submitObject">
                <font style="color:white">預約洽詢</font>
              </v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn color="red" block @click="selectedArray=[]">
                <font style="color:white">全部取消</font>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="800px" v-if="dialog">
      <InterpreterDetail :memberItem="memberItem" v-on:childDialog="parentDialog"></InterpreterDetail>
    </v-dialog>
  </v-form>
</template>
<script>
import InterpreterDetail from "../Common/InterpreterDetail";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getUserId: ["getUserId"],
      getTargetId: ["getTargetId"],
      getIcArray: ["getIcArray"],
      getSearchCase: ["getSearchCase"],
      getQueryObject: ["getQueryObject"],
      idbServerUrl: ["getIdbServerUrl"]
    }),

    filteredKeys() {
      return this.keys.filter(key => key !== `Name`);
    }
  },
  data() {
    return {
      // date: new Date().toISOString().substr(0, 10),
      date: null,
      menu: false,
      dialog: false,
      valid: false,
      firstname: "",
      lastname: "",
      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      rating: 3.5,
      memberItem: {},
      selectedArray: [],
      selectOption: ["A", "B"],
      currentPage: 1,
      maxPage: 0,
      pageSize: 4,
      totalCount: 0,
      itemsPerPageArray: [4, 8, 12],
      items: [],
      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],
      city: String,
      searchCase: {},
      queryObject: {},
      dayArray: this.getCodeDateUtil("dayType"),
      heartArray: [],
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),
      offsetTop: 0
    };
  },
  methods: {
    ...mapActions([
      "updateUser",
      "updateTargetId",
      "updateIcArray",
      "updateSearchCase",
      "updateQueryObject"
    ]),
    submitObject() {
      var vm = this;
      vm.updateIcArray(vm.selectedArray);
      vm.updateQueryObject(vm.queryObject);
      vm.updateSearchCase(vm.searchCase);
      vm.$router.push({
        path: "/contactInterpreter"
      });
    },
    isItemExist(item) {
      let vm = this;
      return vm.selectedArray.some(function(element) {
        return item.uuid == element.uuid;
      });
    },
    isHeartExist(item) {
      let vm = this;
      return vm.heartArray.some(function(element) {
        return item.uuid == element.pocketMemberId;
      });
    },
    addHeart(item) {
      let vm = this;
      var data = {
        memberId: vm.userProfile.memberAccount.uuid,
        pocketMemberId: item.uuid
      };
      vm.axios
        .post(vm.idbServerUrl + "idb/member/pocketMember", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function(response) {
          vm.heartArray.push(response.data);
          //console.log("response " + JSON.stringify(response));
          //console.log("SUCCESS!!!!!!! ");
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log("!!!! " + error);
        });
    },
    deleteHeart(item) {
      let vm = this;
      var pocket = vm.heartArray.find(function(element) {
        return item.uuid == element.pocketMemberId;
      });
      vm.axios
        .delete(
          vm.idbServerUrl + "idb/member/pocketMember/" + pocket.pocketId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          console.log("response " + JSON.stringify(response));
          //console.log("SUCCESS!!!!!!! ");
          vm.heartArray.splice(vm.findHeartIndex(item), 1);
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log("!!!! " + error);
        });
    },
    findItemIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.selectedArray.find(function(element, index) {
        if (item.uuid == element.uuid) itemIndex = index;
      });
      return itemIndex;
    },
    findHeartIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.heartArray.find(function(element, index) {
        if (item.uuid == element.pocketMemberId) itemIndex = index;
      });
      return itemIndex;
    },
    selectedArrayPushObject(item) {
      var vm = this;
      var selectedFlag = false;
      vm.selectedArray.forEach(function(element) {
        if (element.name == item.name) {
          selectedFlag = true;
        }
      });
      if (!selectedFlag) {
        vm.selectedArray.push(item);
      }
    },
    nextPage() {
      if (this.currentPage + 1 <= this.maxPage) this.currentPage += 1;
      this.getHeartList();
    },
    formerPage() {
      if (this.currentPage - 1 >= 1) this.currentPage -= 1;
      this.getHeartList();
    },
    updateItemsPerPage(number) {
      this.pageSize = number;
      this.getHeartList();
    },
    parentDialog() {
      this.dialog = !this.dialog;
    },
    getHeartList() {
      let vm = this;
      var queryObjectStr = JSON.stringify({
        memberId: vm.userProfile.memberAccount.uuid
      });
      var queryPagerStr = JSON.stringify({
        pageSize: vm.pageSize,
        currentPage: vm.currentPage,
        sortColumnNameList: ["createDate"]
      });

      var criterionStr = JSON.stringify({});
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/pocketMember?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          //var dataResponse = JSON.stringify(response.data.resultList);
          //console.log("Pocket \n" + dataResponse);
          vm.heartArray = response.data.resultList;
          vm.currentPage = response.data.currentPage;
          vm.maxPage = response.data.maxPage;
          vm.pageSize = response.data.pageSize;
          vm.totalCount = response.data.totalCount;

          var memberIdArray = [];
          vm.heartArray.forEach(element => {
            memberIdArray.push({
              propertyName: "uuid",
              value: element.pocketMemberId
            });
          });
          //撈memberAccount指定給items

          if (memberIdArray.length != 0) {
            var queryMemberStr = JSON.stringify({ type: "CCC" });

            var queryMemberPagerStr = JSON.stringify({
              pageSize: -1,
              currentPage: 1
            });
            var memberCriterionStr = JSON.stringify({
              in: memberIdArray
            });
            vm.axios
              .get(
                vm.idbServerUrl +
                  "idb/member/memberAccount?queryString=" +
                  encodeURIComponent(queryMemberStr) +
                  "&queryPager=" +
                  encodeURIComponent(queryMemberPagerStr) +
                  "&criterion=" +
                  encodeURIComponent(memberCriterionStr),
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: vm.$localStorage.get("idb_login_token")
                  }
                }
              )
              .then(function(response) {
                vm.items = response.data.resultList;
                if (vm.items != null && vm.items.length>0) {
                  vm.items.forEach(element => {
                    if (element.caseCount == null) {
                      element.caseCount = 0;
                    }
                  });
                }
                //console.log("Items \n" + JSON.stringify(response.data.resultList));
              })
              .catch(function(error) {
                vm.handErrorUtil(error);
                //console.log(error);
              });
          }
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    }
  },
  created() {},
  mounted() {
    var vm = this;
    window.addEventListener("scroll", function() {
      var scrollPos = document.documentElement.scrollTop;
      if (scrollPos < 0) scrollPos = 0;
      if (vm.selectedArray.length > 4) scrollPos = 0;
      vm.offsetTop = scrollPos;
    });
    vm.getHeartList();
  }
};
</script>




